export function thresholdColor(status) {
  if (status === 'limit') return 'error'
  if (status === 'critical') return 'error'
  if (status === 'warning') return 'warning'
  return 'success'
}

export function quotaPeriodBounds(usage) {
  if (!usage || !usage.period_start || !usage.reset_at) {
    return null
  }
  return {
    start: usage.period_start,
    resetAt: usage.reset_at,
  }
}

export function quotaPeriodRows(periods, currentPeriodKey, formatTime) {
  const renderTime = formatTime || ((value) => value)
  return (periods || []).map((period) => ({
    periodKey: period.period_key,
    segment: renderTime(period.segment_start) + ' – ' + renderTime(period.segment_end),
    quotaPeriod: renderTime(period.period_start) + ' – ' + renderTime(period.reset_at),
    calls: Number(period.calls || 0),
    scope: period.period_key === currentPeriodKey
      ? 'Current quota period'
      : 'Outside current quota period',
  }))
}

export function explorerHasFilters(selectedTokens, selectedEndpoints) {
  return (selectedTokens && selectedTokens.length > 0)
    || (selectedEndpoints && selectedEndpoints.length > 0)
}

export function filterScopeCaption(filterActive, selectedTokens, selectedEndpoints, showSummed) {
  if (!filterActive) {
    return 'Showing organization total for the selected range.'
  }
  const parts = []
  if (selectedTokens.length) {
    parts.push(`${selectedTokens.length} token${selectedTokens.length === 1 ? '' : 's'}`)
  }
  if (selectedEndpoints.length) {
    parts.push(`${selectedEndpoints.length} endpoint${selectedEndpoints.length === 1 ? '' : 's'}`)
  }
  const joined = parts.join(' and ')
  if (showSummed) {
    return `Showing one summed line for ${joined}. Tables stay filtered to the same scope.`
  }
  return `Showing ${joined} as separate lines. Tables stay filtered to the same scope.`
}

export function filterDegradedMessage(filter) {
  if (!filter || filter.degraded !== 'missing_pairs') {
    return ''
  }
  return (
    'Correlated PAT × endpoint history is not available for this range yet, so the '
    + 'endpoint filter could not be applied. Showing token totals instead. Run '
    + 'scripts/backfill_correlated_usage_pairs.py after deploying correlated writes.'
  )
}

export function correlationCoverageMessage(coverage) {
  if (!coverage || coverage.complete || !coverage.needs_pairs) {
    return ''
  }
  if (!coverage.earliest_correlated_at) {
    return 'Correlated PAT × endpoint history is not available for this range yet. Run the pair backfill after deploying correlated writes.'
  }
  return `Correlated PAT × endpoint data begins at ${coverage.earliest_correlated_at}. Earlier minutes in this range may omit cross-dimension tables.`
}

export function dailyRowsFromActivity(activity) {
  if (activity && activity.daily && activity.daily.length) {
    return activity.daily
  }
  const series = (activity && activity.visibleSeries && activity.visibleSeries()) || []
  const total = series.find((item) => item.kind === 'summary' || item.kind === 'total')
  if (!total) {
    return []
  }
  const perDay = {}
  ;(total.values || []).forEach((point) => {
    if (!point.timestamp) {
      return
    }
    const day = point.timestamp.slice(0, 10)
    perDay[day] = (perDay[day] || 0) + Number(point.value || 0)
  })
  return Object.keys(perDay).sort().map((day) => ({ key: day, used: perDay[day] }))
}
